import React, { useMemo } from 'react';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import { ITEMTYPE } from '../../../../../../../Constants/ItemType.Constants';
import { st, classes } from '../../../../../../Shared/SharedText.st.css';
import { classes as itemNameClasses } from './ItemName.st.css';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getSearchStatus } from '../../../../../../Services/Search.service';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import { getRootFolder } from '../../../../../../Services/RootFolder.service';
import { getAppSettings } from '../../../../../../Services/AppSettings.service';
import { getTableSettings } from '../../../../../../Services/TableSettings.service';
import { TableColumns } from '../../../../../../../Constants/TableHeader.Constants';
import SearchSubtitle from './SearchSubtitle';
import formatBytes from '../../../../../../Shared/helper/FileSize';
import { useAppContext } from '../../../../../../Shared/AppContext';

const ItemNameSubTitle = (props: any) => {
  const { item } = props;
  const { compId } = useAppContext();
  const { t } = useTranslation();
  const [, searchStatus]: any = useObservable(getSearchStatus(compId));
  const [, rootFolder]: any = useObservable(getRootFolder(compId));
  const [, AppSettings]: any = useObservable(getAppSettings());
  const [, tableSettings]: any = useObservable(getTableSettings(compId));
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';

  const Items: string = t('app.widget.actions.itemName.Items', {
    numberOfItems:
      ITEMTYPE.FOLDER in item ? item?.folderFields?.childrenCount : null,
  });
  const showSearchSubTitle =
    rootFolder !== undefined &&
    searchStatus !== undefined &&
    searchStatus === true;

  const subtitleText: string | null = useMemo<string | null>(() => {
    const isContributorsEnabled =
      tableSettings?.find((data: any) => data.id === TableColumns.CONTRIBUTORS)
        ?.value ?? false;
    if (ITEMTYPE.FILE in item) {
      if (isMobile) {
        return isContributorsEnabled
          ? t('app.widget.itemName.createdBy', {
              createdBy: item.createdByName,
            })
          : null;
      }
      return formatBytes(item.fileFields.size, 2, t);
    }
    if (ITEMTYPE.FOLDER in item) {
      return `${Items}`;
    }
    return null;
  }, [tableSettings, item, isMobile, t, Items]);

  const subtitleTextWithSuffix: string | null = useMemo<string | null>(
    () =>
      subtitleText && showSearchSubTitle && isMobile
        ? `${subtitleText},`
        : subtitleText,
    [subtitleText, showSearchSubTitle, isMobile],
  );
  return (
    <div
      className={
        isMobile
          ? itemNameClasses.itemSubtitleMobile
          : itemNameClasses.itemSubtitle
      }
    >
      <Text className={st(classes.textAndDividersColor, { isMobile })}>
        {subtitleTextWithSuffix}
      </Text>

      {showSearchSubTitle ? (
        <SearchSubtitle item={item} isMobile={isMobile} />
      ) : null}
    </div>
  );
};

export default ItemNameSubTitle;
